import { Boundary } from "./Boundary";
import { MileageRecord } from "./MileageRecord";

export function toBoundary(raw: any): Boundary {
  return {
    id: raw.Id,
    name: raw.Name,
    mileageRecords:
      Array.isArray(raw.MileageRecords) ?
        raw.MileageRecords.map(toMileageRecord)
      : [],
    envelope:
      raw.MercatorEnvelope ?
        [
          raw.MercatorEnvelope.MinX,
          raw.MercatorEnvelope.MinY,
          raw.MercatorEnvelope.MaxX,
          raw.MercatorEnvelope.MaxY,
        ]
      : [0, 0, 0, 0],
    urlTag: raw.UrlTag,
  };
}

function toMileageRecord(raw: any): MileageRecord {
  return {
    year: raw.Year ?? null,
    mileage: raw.Mileage ?? null,
    percentageChange: raw.PercentageChange ?? null,
  };
}
